import { RegexEnum } from '../../libs/enums';
import { mustBeFilled, mustBeLessThan, mustMatchFormat } from '../../libs/validators';

export const inputFirstNameConfig = {
  description: 'Comme inscrits sur votre acte de naissance',
  label: 'Prénoms de naissance',
  name: 'firstName',
  validators: {
    format: [
      mustMatchFormat(
        RegexEnum.PERSON,
        'Veuillez utiliser uniquement des caractères alpha-numériques ou de ponctuations',
      ),
      mustBeLessThan(256),
    ],
    submit: mustBeFilled(
      'Veuillez renseigner vos prénoms de naissance ou cocher la case si vous ne disposez pas de prénom renseigné sur votre acte de naissance.',
    ),
  },
};
